import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import Select from "../../../Form/Select";

export const OnlineDot = styled(Box)(() => ({
  height: "8px",
  width: "8px",
  background: "#38CFC4",
  borderRadius: "50%",
}));

export const OfflineDot = styled(Box)(() => ({
  height: "8px",
  width: "8px",
  background: "#D92D20",
  borderRadius: "50%",
}));

export const NotOutlinedSelect = styled(Select)(() => ({
  "& .MuiOutlinedInput-notchedOutline": {
    display: "none",
  },
  "& .MuiInputBase-input": {
    color: "#465869",
    fontWeight: 700,
    fontSize: "16px",
  },
}));

const default_text_color = "#93A9BD";
const default_background_color = "#FFF";

const headerCollapseStyle = {
  background: default_background_color,
  borderRadius: "8px",
  height: "40px",
  padding: "12px",
  margin: "0px 6px 0px 6px",
};

const headerStyle = {
  background: default_background_color,
  borderRadius: "8px",
  borderBottomLeftRadius: "0px",
  borderBottomRightRadius: "0px",
  height: "40px",
  padding: "12px",
  margin: "0px 6px 0px 6px",
};

const styles = makeStyles((theme) => {
  return {
    headerConsultant: {
      background: default_background_color,
      borderRadius: "8px",
      height: "40px",
      padding: "12px",
      marginRight: "6px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      "& span": {
        fontFamily: "Manrope",
        fontStyle: "Normal",
      },
    },
    headerCollapsed: { ...headerCollapseStyle },
    headerInventoryCollapsed: {
      ...headerCollapseStyle,
      display: "flex",
      alignItems: "center",
    },
    header: { ...headerStyle },
    headerInventory: { ...headerStyle, display: "flex", alignItems: "center" },
    tabsHeader: {
      margin: "0px 6px 0px 6px",
    },
    tabsHeaderCollapsed: {
      borderRadius: "8px",
      height: "40px",
      margin: "0px 6px 0px 6px",
    },
    tabsList: {
      margin: 0,
      listStyle: "none",
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      width: "100%",
      height: 40,
      borderRadius: 8,
      gap: 2,
    },
    tabsItem: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: default_background_color,
      font: "700 14px/16px Manrope",
      color: default_text_color,
      "&:not(:last-child)": {
        width: "calc((100% - 48px)/2)", // TODO Camila: change back to 3 when estimate tab is ready to be shown
      },
      "&:last-child": {
        width: 50,
        borderRadius: "0 8px 8px 0",
      },
      "&:first-child": {
        borderRadius: "8px 0 0 8px",
      },
    },
    taskNumber: {
      fontWeight: 700,
      fontSize: "16px",
      color: "#9CA6AF",
    },
    customerName: {
      fontWeight: 700,
      fontSize: "16px",
      color: "#465869",
    },
    status: {
      fontWeight: 400,
      fontSize: "14px",
      color: "#465869",
    },
    inventoryHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",

      "& > div": {
        display: "flex",
        alignItems: "center",
        gap: "10px",
      },
    },
  };
});

export default styles;
